import { gql } from "@apollo/client";
import { gtag, install } from "ga-gtag";

import apolloClient from "./apolloClient";
import { GA_MEASURE_ID, ONSEN_APP } from "./environment";
import { progressBar } from "./useProgressBar";

const CAMPAIGN_PARAMS = {
  campaign_id: "utm_id",
  campaign_source: "utm_source",
  campaign_medium: "utm_medium",
  campaign_name: "utm_campaign",
  campaign_term: "utm_term",
  campaign_content: "utm_content",
};

// GA4 freezes session attribution on the session's first event, so state the campaign up front
// rather than letting gtag re-derive it from whichever event happens to open the session.
function bootCampaign() {
  const search = new URLSearchParams(window.location.search);
  return Object.fromEntries(
    Object.entries(CAMPAIGN_PARAMS)
      .map(([param, utm]) => [param, search.get(utm)])
      .filter(([, value]) => value),
  );
}

export function initGA() {
  if (ONSEN_APP) return;
  install(GA_MEASURE_ID, {
    send_page_view: false,
    // gtag.js loads async, so pin the URL we booted on before the app can navigate away from it.
    page_location: window.location.href,
    ...bootCampaign(),
  });
}

const gaEventSharedParams = {};

export function gaSetSharedEventParams(params) {
  const oldOrgId = gaEventSharedParams.org_id;
  Object.assign(gaEventSharedParams, params);
  const newOrgId = gaEventSharedParams.org_id;
  if (newOrgId !== oldOrgId) {
    progressBar(async () => {
      let orgAnalyticsName = null;
      if (newOrgId) {
        const result = await apolloClient.query({
          query: gql`
            query gaSetSharedEventParams($id: ID!) {
              org(id: $id) {
                gaId
                analyticsName
              }
            }
          `,
          variables: { id: newOrgId },
          fetchPolicy: "cache-first",
        });
        orgAnalyticsName = result.data?.org?.analyticsName;
      }
      gaEventSharedParams.org_name = orgAnalyticsName;
    });
  }
}

export function gaEvent(eventName, params) {
  // TODO: gtag won't work in Capacitor runtime as for now. Implement this through firebase SDK instead.
  if (ONSEN_APP) return;
  return gtag("event", eventName, {
    // Report the URL the event happened on, not the one pinned at install time.
    page_location: window.location.href,
    ...gaEventSharedParams,
    ...params,
  });
}
